import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ExaminerCreateRequest, ExaminersClient} from '../../../generated-client/generated-api-client';
import {ToastrService} from 'ngx-toastr';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {TenantService} from '../../../services/tenant.service';
import {
  isFormModifiedDataService,
  SimpleNavigationService
} from "../../../services/data-services/navigation-data-services";
import {ValidatorPatterns} from "../../../custom-validators/validatorPatterns";

@Component({
  selector: 'app-examiner-form',
  templateUrl: './examiner-form.component.html',
  styleUrls: ['./examiner-form.component.sass'],
})
export class ExaminerFormComponent implements OnInit {
  examinerForm!: FormGroup;
  isLoading: boolean = true;
  @Input() examReportId: string | undefined;
  @Input() navigateToUrl!: string;
  @Input() navigateBackUrl!: string;

  constructor(
    private router: Router,
    private client: ExaminersClient,
    private toastr: ToastrService,
    private errorProcessorService: ErrorProcessorService,
    private _tenantService: TenantService,
    private _isFormModifiedDataService: isFormModifiedDataService,
    private _navigationService: SimpleNavigationService
  ) {}

  ngOnInit(): void {
    this.examinerForm = new FormGroup({
      title: new FormControl('', [Validators.maxLength(50)]),
      email: new FormControl('', [Validators.pattern(ValidatorPatterns.email), Validators.required, Validators.maxLength(50)]),
      surname: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      forename: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      forename2: new FormControl('', [Validators.maxLength(50)]),
      idNumber: new FormControl('', [Validators.maxLength(100)]),
    });
    this.isLoading = false;
    this.examinerForm.valueChanges.subscribe(() => {
      this._isFormModifiedDataService.isFormModified = true;
    });
    this.errorProcessorService.formGroup = this.examinerForm;
  }

  get title() {
    return this.examinerForm.get('title')!;
  }

  get email() {
    return this.examinerForm.get('email')!;
  }

  get surname() {
    return this.examinerForm.get('surname')!;
  }

  get forename() {
    return this.examinerForm.get('forename')!;
  }

  get forename2() {
    return this.examinerForm.get('forename2')!;
  }

  get idNumber() {
    return this.examinerForm.get('idNumber')!;
  }

  onGoBack(){
    this._navigationService.navigateTo(this.navigateBackUrl);
  }

  onSubmit() {
    const request: ExaminerCreateRequest = {
      title: this.title?.value === '' ? null : this.title?.value,
      email: this.email?.value === '' ? null : this.email?.value,
      surname: this.surname?.value === '' ? null : this.surname?.value,
      forename: this.forename?.value === '' ? null : this.forename?.value,
      forename2: this.forename2?.value === '' ? null : this.forename2?.value,
      idNumber: this.idNumber?.value === '' ? null : this.idNumber?.value,
      examReportId: this.examReportId,
      tenantId: this._tenantService.activeTenantId,
    };
    this.client.create(request).subscribe(
      next => {
        if (this.navigateToUrl.includes('exam-reports')) {
          this.toastr.success('Sikeres vizsgabiztos hozzárendelés');
        }
        this._isFormModifiedDataService.isFormModified = false;
        this.router.navigate([this.navigateToUrl]);
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }

}
